module.exports = __webpack_public_path__ + "media/brands/benzhou-ce611ada.png";